<template>
  <div
    class="px-4 flex flex-col mb-3.5"
  >
    <div
      class="border border-border-normal rounded-t-lg w-full h-full flex p-2.5 bg-background-disabled"
    >
      <BaseText
        type="body"
        size="xs"
        class="mr-auto w-1/3"
      >
        User
      </BaseText>
      <BaseText
        type="body"
        size="xs"
        class="mr-auto w-1/3"
      >
        Connected IG
      </BaseText>
      <BaseText
        type="body"
        size="xs"
        class="mr-auto w-1/3"
      >
        Linked Boards
      </BaseText>
    </div>
    <div
      class="border border-border-normal flex flex-col divide-y divide-border-normal border-t-0"
    >
      <div
        v-for="(teamMember, index) in team"
        :key="index"
        class="flex gap-1.5 items-center p-2 relative"
      >
        <div
          class="flex items-center w-1/3"
        >
          <svg
            v-if="teamMember.igWaitingVerification === false"
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="7"
            viewBox="0 0 6 7"
            fill="none"
            class="mr-1.5"
          >
            <circle
              cx="3.00001"
              cy="3.58939"
              r="2.66727"
              fill="#40C4AA"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="7"
            viewBox="0 0 6 7"
            fill="none"
            class="mr-1.5"
          >
            <circle
              cx="3.00001"
              cy="3.48173"
              r="2.66727"
              fill="#F2994A"
            />
          </svg>
          <BaseText
            type="body"
            size="xs"
            class="text-text-muted whitespace-nowrap truncate"
          >
            {{ teamMember.email }}
          </BaseText>
        </div>
        <BaseText
          v-if="teamMember.igUsername"
          type="body"
          size="xs"
          class="text-text-muted w-1/3"
        >
          @{{ teamMember.igUsername }}
        </BaseText>
        <BaseText
          v-else
          type="body"
          size="xs"
          class="text-text-disabled w-1/3"
        >
          Not Connected
        </BaseText>
        <div
          class=" w-1/3 flex items-center gap-1.5"
        >
          <div
            class="items-center border border-border-hover rounded-md px-1.5 py-0.5 bg-background-normal text-text-muted flex"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="h-3.5 w-3.5 mr-1.5"
            >
              <path
                d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                fill="#5E6678"
              />
            </svg>
            <BaseText
              type="body"
              size="xs"
              class="text-text-muted"
            >
              {{ teamMember.igBoardIds?.length ? getBoardName(teamMember.igBoardIds[0]) : 'None' }}
            </BaseText>
          </div>
          <BaseText
            v-if=" teamMember.igBoardIds?.length"
            type="body"
            size="xs"
            class="text-text-muted "
          >
            {{ getExcessBoards(teamMember) ? `+${getExcessBoards(teamMember)}` : '' }}
          </BaseText>
        </div>
        <div
          v-if="teamMember.user_id === getUser.user_id"
          class="flex items-center -mx-2 absolute w-full"
        >
          <div
            class="flex items-center ml-auto cursor-pointer text-text-subdued hover:text-text-muted transition-colors duration-100 ease-in-out"
            @click="$emit('showIgModal')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              class="h-4"
            >
              <path
                d="M11.9406 6.08349L14.3037 3.72033C14.9546 3.06946 16.0099 3.06946 16.6608 3.72033L18.0537 5.11331C18.7046 5.76418 18.7046 6.81946 18.0537 7.47033L15.6906 9.83349M11.9406 6.08349L3.67874 14.3453C3.36618 14.6579 3.19058 15.0818 3.19058 15.5238V18.5835H6.25023C6.69225 18.5835 7.11618 18.4079 7.42874 18.0953L15.6906 9.83349M11.9406 6.08349L15.6906 9.83349"
                stroke="currentColor"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <BaseText
              type="body"
              size="xs"
              class="pr-4"
            >
              Edit
            </BaseText>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex gap-1.5 items-center p-2 pl-5 border border-t-0 border-border-normal rounded-b-lg"
    >
      <BaseText
        type="body"
        size="xs"
        class="text-text-disabled mr-auto w-max ml-0.5"
      >
        Invite more users to add additional connections.
      </BaseText>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api/firebase'
export default {
  name: 'IntegrationsCard',
  props: {
    team: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUser', 'getTeam']),
    ...mapGetters('BoardsModule', ['getBoards'])
  },
  methods: {
    getBoardName (boardId) {
      const board = this.getBoards.find(b => b.id === boardId)
      return board?.name
    },
    getExcessBoards (teamMember) {
      return teamMember?.igBoardIds?.length > 1 ? teamMember?.igBoardIds?.length - 1 : null
    },
    async getTeamMembers () {
      return API.Teams.getTeamMembers()
    }
  }
}
</script>
